import { Component, Input, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-lfsa-gh-pareto',
  templateUrl: './lfsa-gh-pareto.component.html',
  styleUrls: ['./lfsa-gh-pareto.component.css']
})
export class LfsaGhParetoComponent implements OnInit {

  @Input() dataList: Highcharts.SeriesOptionsType [];
  @Input() categoria: string [];
  @Input() loading: boolean = false;
  @Input() idComponent: string;
  @Input() title: string;
  @Input() subtitulo:string;
  @Input() colors: any[] = [];

  constructor() { }
  chart: Chart;
  ngOnInit() {
    this.init();
  }
  

  addPoint() {
    if (this.chart) {
      this.chart.addPoint(Math.floor(Math.random() * 10));
    } else {
      alert('init chart, first!');
    }
  }

  addSerie() {
    /*this.chart = new Chart({
      chart: {
        type: 'line'
      },
      title: {
        text: 'Linechart'
      },
      credits: {
        enabled: false
      },
      series: [
        {
          name: 'Line 1',
          type:'line',
          data: [2, 2, 3]
        }
      ]
    });*/

    this.chart.addSeries({
      name: 'Line ' + Math.floor(Math.random() * 10),
      type:'pie',
      data: [
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 10)
      ]
    },true,true);
  }

  removePoint() {
    this.chart.removePoint(this.chart.ref.series[0].data.length - 1);
  }

  removeSerie() {
    this.chart.removeSeries(this.chart.ref.series.length - 1);
  }

  init() {

  let seriesd :Highcharts.SeriesOptionsType[] = [{
    name: 'Diferencia',
    type: 'column',
    yAxis: 1,
    data: [608, 432, 238, 106, 37],
    tooltip: {
        valueSuffix: ' -'
    }

    }, {
        name: 'Procentaje',
        type: 'spline',
        data: [41, 70, 86, 93, 95],
        tooltip: {
            valueSuffix: '%'
        }
    }];
  //---------------------------------------------------
    let chart = new Chart({
      chart: {
          zoomType: 'xy'
      },
      title: {
          text: this.title
      },
      subtitle: {
          text: this.subtitulo
      },
      xAxis: [{
          categories:this.categoria,
          crosshair: true,
          id:'values'
      }],
      yAxis: [{ // Primary yAxis
          labels: {
              format: '{value}°%',
              style: {
                  color: Highcharts.getOptions().colors[1]
              }
          },
          title: {
              text: 'Porcentaje',
              style: {
                  color: Highcharts.getOptions().colors[1]
              }
          },
          max: 100,
          min: 0,
      }, { // Secondary yAxis
          title: {
              text: 'Diferencia',
              style: {
                  color: Highcharts.getOptions().colors[0]
              }
          },
          labels: {
              format: '{value} ',
              style: {
                  color: Highcharts.getOptions().colors[0]
              }
          },
          opposite: true
      }],
      tooltip: {
          shared: true
      },
      legend: {
          layout: 'vertical',
          align: 'right',
          x: -120,
          verticalAlign: 'top',
          y: 100,
          floating: true,
          backgroundColor:
              Highcharts.defaultOptions.legend.backgroundColor || // theme
              'rgba(255,255,255,0.25)'
      },
      plotOptions: {
        series: {
            cursor: 'pointer',
            point: {
                events: {
                    click: function () {
                        /*alert(
                            'Category: ' +this.category.split('-')[1]  + ', value: ' + this.y
                        );*/
                        console.log(this.category.split('-')[1].trim());
                        console.log(this.series.userOptions.mapData);
                        console.log("material", this.category.split('-')[0].trim());
                        window.open('/perform/reportes-gauss?ean14='+this.category.split('-')[1].trim()+
                        '&material='+  this.category.split('-')[0].trim()+  //Ticket 26766 Problemas en plataforma PERFOR con referencia de artículos códigos EAN14
                        this.series.userOptions.mapData, "_blank");
                        //this.route.navigate(['/perform/reportes-gauss', { idPedidoCabecera: this.category.split('-')[1] }]);
                    }
                }
            }
        }
    },
    series: this.dataList
  });
    //chart.addPoint(4);
    this.chart = chart;
    //chart.addPoint(5);

    chart.ref$.subscribe(console.log);
  }

}
